import { useEffect, useState } from "react";

type CountryStateCityModule = typeof import("country-state-city");

export function useCountryStateCity() {
  const [geoModule, setGeoModule] = useState<CountryStateCityModule | null>(
    null,
  );

  useEffect(() => {
    void import("country-state-city").then(setGeoModule);
  }, []);

  return geoModule;
}
